<!-- 企业认证 -->
<template>
	<div style="width: 700px;">
		<div style="font-size: 16px;color: #767794;margin-top: 40px;">
			当前认证公司:&nbsp;&nbsp;<span style="cursor:pointer;">{{form1.company_name}}</span>
			<img src="../assets/img/edit.png" style="vertical-align: bottom;margin-left: 10px;" @click="open" />
		</div>
		<div style="font-size: 16px;color: #767794;margin-top: 20px;">
			本认证服务由第三方机构金保信社保卡科技有限公司提供
		</div>
		<div
			style="width: 500px;height: 200px;background-color: #fff;border-radius: 5px;box-shadow: 0 0 5px 1px rgb(198, 198, 198);margin: 20px auto 10px auto;">
			<div style="display: flex;height: 140px;align-items: center;justify-content: center;">
				<img src="../assets/img/Frame1.png" style="vertical-align: bottom;" />
				<span
					style="width: 100px;height: 5px;background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);border-radius: 5px;margin-right: 8px;"></span>
				<img src="../assets/img/Frame2.png" style="vertical-align: bottom;" />
			</div>
			<div style="font-size: 16px;color: #767794;text-align: center;margin-top: -10px;">社保缴存信息验证</div>
			<div style="font-size: 16px;color: #767794;text-align: center;margin-top: 10px;">验证您的社保缴存记录</div>
		</div>
		<div style="font-size: 20px;color: #656587;font-weight: bold;margin-top: 35px;">
			需验证您在以下公司的社保缴存记录
		</div>
		<div style="font-size: 16px;color: #767794;margin-top: 10px;">
			公司名称&nbsp;&nbsp;&nbsp;<span style="cursor:pointer;">{{form1.company_name}}</span>
		</div>
		<div style="font-size: 16px;color: #767794;margin-top: 10px;">
			缴存时间&nbsp;&nbsp;&nbsp;<span style="cursor:pointer;">{{form1.time}}</span>&nbsp;&nbsp;&nbsp;之前
		</div>

		<div style="font-size: 16px;color: #767794;line-height: 28px;margin-top: 30px;">
			<el-checkbox style="transform: scale(1.5);" v-model="form1.checkBox"></el-checkbox>
			&nbsp;&nbsp;
			<span style="width: calc(100% - 30px);float: right;">
				我已同意<span
					style="color:deepskyblue;cursor:pointer;">《信息核验授权协议》</span>确认授权AI多面体使用本人信息进行社保核验并从第三方接收核验结果。点击『开始验证』跳转至第三方页面操作。
			</span>
		</div>
		<div slot="footer" class="dialog-footer" style="display: flex;
		justify-content: space-between;margin-top: 80px;">
			<el-button style="width: 48%;height: 50px;background: linear-gradient(to right, #5ca4ef, #b240ff);-webkit-background-clip: text;
			    background-clip: text;color: transparent;background-color: rgba(210, 211, 208, 0.1);
		      border: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);border-radius: 10px;"
				type="primary" @click="goBack">更换其他验证方式</el-button>

			<el-button style="width: 48%;height: 50px;background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
			  border: transparent;border-radius: 10px;" type="primary" @click="handleNext">开始验证</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getCertification,
		getSocial
	} from '@/api/socialInsurance'
	export default {
		data() {
			return {
				form: {},
				form1: {
					company_name: "深圳市屿智同行科技有限公司",
					time: '2025年10月01日',
					checkBox: false,
				},
				dialogFormVisible: false,
			};
		},
		created() {
			this.form = JSON.parse(this.$route.query.form)
			this.form1.company_name = this.form.company_name
		},
		methods: {
			open() {
				this.$prompt('请输入公司名称', '编辑', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					getCertification({
						company_name: value,
					}).then(async res => {
						if (res.data.code === 200) {
							this.form1.company_name = res.data.data.company_name
							this.form.company_name = res.data.data.company_name
						} else {
							this.form1.company_name = this.form.company_name
							this.$message({
								type: 'info',
								message: '您输入的公司不存在！'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消修改'
					});
				});
			},
			goBack() {
				this.$confirm('确认更换其他验证方式吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/store/business/businessVerificationFunc',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			handleNext() {
				// 触发表单验证
				getSocial({
					company_name: this.form1.company_name,
					deposit_date_start: '2025-10-01',
					deposit_date_end: '2025-10-31',
				}).then(async res => {
					if (res.data.code === 1) {
						this.$message({
							type: 'success',
							message: '验证成功'
						});
					} else {

					}
				})
			},
		},
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 0px 18px 18px 0px;
		font-size: large;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.submitButton {
		width: 180px;
		height: 50px;
		border-radius: 18px;
		background-image: linear-gradient(90deg,
				rgba(126, 180, 235, 1) 0,
				rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-top: 20px;
		font-size: x-large;
		cursor: pointer;
	}

	/* 自定义表单样式 - 字体变大加粗 */
	::v-deep .custom-form {
		/* 调整整体表单的字体大小 */
		font-size: 18px;
		margin-top: 10px;
	}

	/* 表单项标签样式 */
	::v-deep .custom-form .el-form-item__label {
		font-weight: bold;
		/* 标签加粗 */
		font-size: 18px;
		/* 标签字体稍大于输入框 */
		color: #333;
		/* 加深标签颜色 */
	}

	/* 输入框内容样式 */
	::v-deep .custom-form .el-input__inner {
		font-size: 18px;
		/* 输入框字体大小 */
		padding: 10px 15px;
		/* 加大输入框内边距，让整体更大气 */
	}
</style>